// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"9ac135ec","279":"625d6bf7","787":"ef0959af"}[chunkId] + ".chunk.js";
};